// Buyer "Skip for now" on the safety step (Sam, Oct 23 2026 9:56-9:59 AM). Client-only;
// server guards and checkout still require the step at booking time.
const KEY = 'slSetupSkipped';
const ls = () => (typeof window !== 'undefined' && window.localStorage ? window.localStorage : null);
export const EARNER_ROLES = ['listen', 'both'];
export const markSetupSkipped = userId => { try { if (userId) ls()?.setItem(`${KEY}:${userId}`, '1'); } catch (e) {} };
export const isSetupSkipped = userId => { try { return !!userId && ls()?.getItem(`${KEY}:${userId}`) === '1'; } catch (e) { return false; } };
// Sam 10:05 AM (final): buyers skip safety/email; earners may skip any step after guidelines/email,
// but can't be booked or earn until every step is done (server publish + booking guards).
export const canSkipStep = (role, step) =>
  role === 'talk' ? step === 'trust' || step === 'email' : EARNER_ROLES.includes(role) && !!step && !['email', 'guidelines'].includes(step);
